// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"styles_breadcrumb__HjbA3","breadcrumbItem":"styles_breadcrumbItem__1Y5i9","breadcrumbItemLink":"styles_breadcrumbItemLink__104Rm"};